"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TextInput_1 = __importDefault(require("./TextInput"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const useInputForm_1 = require("../../hooks/useInputForm");
const convertPenniesToDollars = (value) => {
    if (value === '' || (typeof value === 'string' && value.endsWith('.'))) {
        return value;
    }
    return parseFloat(`${value / 100}`).toFixed(2);
};
const convertDollarsToPennies = (value) => {
    if (value === '' || (typeof value === 'string' && value.endsWith('.'))) {
        return value;
    }
    // Must do toFixed() or else 19.99 * 100 = 1998.9999998
    return parseInt(`${(value * 100).toFixed()}`, 10);
};
const PriceInput = (props) => {
    const inputValue = useInputForm_1.useInputValue(props);
    const onInputChange = useInputForm_1.useInputFormChange(props);
    const [localValue, setLocalValue] = react_1.useState(convertPenniesToDollars(inputValue));
    react_1.useEffect(() => {
        setLocalValue(convertPenniesToDollars(inputValue));
    }, [inputValue]);
    const onChange = react_1.useCallback((e) => {
        /* Don't do any manipulation yet, this is done on blur. */
        setLocalValue(e.target.value);
        /* Disable automatic form binding. */
        return false;
    }, []);
    const { onBlur } = props;
    const onBlurHandle = react_1.useCallback((e) => {
        setLocalValue(e.target.value);
        onInputChange(e).catch(console.error);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onInputChange, onBlur]);
    return (react_1.default.createElement(TextInput_1.default, Object.assign({ type: "number", "data-price": "true", step: "0.01", min: 0 }, props, { value: localValue, onChange: onChange, onBlur: onBlurHandle })));
};
exports.default = withJourney_1.default('j-price-input', PriceInput);
